import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Shield, Mail, Lock, AlertCircle } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import './AdminBlogLogin.css';

const AdminBlogLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await fetch('/api/admin-blog-login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();

      if (response.ok) {
        // Store admin session
        localStorage.setItem('adminBlogToken', data.token);
        localStorage.setItem('adminBlogUser', JSON.stringify(data.user));
        // Navigate to admin blogs
        navigate('/admin/blogs');
      } else {
        setError(data.message || 'Invalid credentials or no access');
      }
    } catch (err) {
      setError('Failed to connect to server. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-blog-login-page">
      <motion.div
        className="admin-blog-login-container"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <div className="admin-blog-login-header">
          <Shield size={48} className="admin-shield-icon" />
          <h1>Admin Blog Access</h1>
          <p>Sign in with your authorized credentials</p>
        </div>

        <form onSubmit={handleLogin} className="admin-blog-login-form">
          {error && (
            <motion.div
              className="admin-blog-error"
              initial={{ opacity: 0, x: -10 }}
              animate={{ opacity: 1, x: 0 }}
            >
              <AlertCircle size={18} />
              <span>{error}</span>
            </motion.div>
          )}

          <div className="admin-blog-form-group">
            <label htmlFor="email">
              <Mail size={18} />
              Email Address
            </label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              required
              disabled={loading}
            />
          </div>

          <div className="admin-blog-form-group">
            <label htmlFor="password">
              <Lock size={18} />
              Password
            </label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your password"
              required
              disabled={loading}
            />
          </div>

          <button
            type="submit"
            className="admin-blog-login-btn"
            disabled={loading}
          >
            {loading ? (
              <>
                <div className="admin-blog-spinner"></div>
                Verifying...
              </>
            ) : (
              'Sign In'
            )}
          </button>
        </form>

        <div className="admin-blog-login-footer">
          <p>Only authorized users with admin blog access can sign in</p>
        </div>
      </motion.div>
    </div>
  );
};

export default AdminBlogLogin;
